import React from 'react';
import { Tooltip } from 'antd';
import { apiHolder as api, apis } from 'api';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailFormat = props => {
    const { showMfDialog, clickMailFormat, setClickMailFormat } = props;
    if (clickMailFormat) {
        trackApi.track('pcMail_click_emailTemplate_writeMailPage');
        showMfDialog();
        setClickMailFormat(false);
    }
    return (React.createElement("div", { className: "mailformat-wrap" },
        React.createElement("div", { className: "click-target" },
            React.createElement(Tooltip, { key: "1", visible: false, placement: "bottomLeft", title: React.createElement("div", { className: "tooltip-wrap" }, getIn18Text('ZAIZHELIYEKE')) },
                React.createElement("div", { className: "tooltip-format" })))));
};
export default MailFormat;
